import React from "react"

const Tab = ({pageActive, index, children}) => (
    <div className={"sr-tab-component"} style={{display: pageActive === index ? "block" : "none"}}>
        {children}
    </div>
)

export default Tab
